export default __webpack_public_path__ + "static/media/High Priest's Necklace.bac0b551.jpg";